<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">supervised_user_circle</mat-icon>
				<span>Benutzerverwaltung</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bLoading" />

			<button
				mat-raised-button
				color="primary"
				[disabled]="bLoading"
				[routerLink]="['Benutzererstellung']"
			>
				<span class="material-icons" style="vertical-align: text-top; margin-right: .5em">person_add</span>
				Neuer Benutzer
			</button>

		</div>

		<div>

			@if( bLoading ) {
				<!-- there is already a spinner higher -->
			}
			@else if( !elements.length ) {
				<div class="accNoElements">
					Kein Benutzer vorhanden
				</div>
			}
			@else {

				<div class="accFilterAndAccordeon">
	
					<mat-form-field
						appearance="outline"
						subscriptSizing="dynamic"
						class="accFilter"
					>

						<mat-label>Filter</mat-label>
						<input
							matInput
							placeholder="Beispiel: John Smith"
							(keyup)="onFilterChanged($event)"
						>
						<mat-icon matSuffix>search</mat-icon>

					</mat-form-field>
	
					<div
						class="accAccordeon"
						[style.--nbColumns]="'4'"
					>
	
						@if( !filteredElements.length ) {
	
							<div class="accNoElements">
								Keine Daten entspricht dem Filter
							</div>
	
						}	
						@else {

							<div
								class="accHeaders"
								[class.accSortIconDesc]="!sortingAsc"
							>

								<div
									class="accCell"
									style="width: 48px; text-align: center;"
								>
									<div class="accHeader"></div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'mitgliedsname'"
									(click)="sortColumn('mitgliedsname')"
									title="Nach Mitgliedernamen sortieren"
								>
									<div class="accHeader">
										<span>Verein</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'mitgliedsname' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>
								
								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'ebeId'"
									(click)="sortColumn('ebeId')"
									title="Nach Benutzernamen sortieren"
								>
									<div class="accHeader">
										<span>Benutzername</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'ebeId' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>
	
								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'name'"
									(click)="sortColumn('name')"
									title="Nach Namen sortieren"
								>
									<div class="accHeader">
										<span>Name</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'name' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div class="accCell">
									<div class="accHeader">
									</div>
								</div>
	
							</div>
								
							<div class="accScrollPanel">
	
								@for( user of filteredElements; track user.ebeId ) {
	
									<div
										class="accRow"
										(click)="clickOnUser(user.ebeId)"
										[class.accRowActive]="expandedUserId == user.ebeId"
										[id]="'userRow_' + user.ebeId"
									>
										<div class="accCell" style="width: 48px; text-align: center;">
											<app-avatar-circle [ebeId]="user.ebeId" size="sm"></app-avatar-circle>
										</div>
										<div class="accCell">
											{{ user.mitgliedsname }}
										</div>
										<div class="accCell">
											{{ user.ebeId }}
										</div>
										<div class="accCell">
											{{ user.ebeVorname }} {{ user.ebeName }}
										</div>
										<div class="accCell">
											@if( user.bMainContact ) {
												<span class="material-icons" title="Hauptansprechpartner">
													support_agent
												</span>
											}
										</div>
									</div>
	
									@if( expandedUserId == user.ebeId ) {
	
										<div
											class="accDetail"
											[@accordeonMe]
										>
											<app-user-editor
												[myInputs]="myInputs"
												[user]="user"
												(reloadUser)="refreshList()" 
												(mainPartnerChanged)="memberHasNewMainPartner(user)"
											/>
											<!--
												(done)="onUserEdited()"
											-->
										</div>
	
									}
	
								}
	
							</div>
	
						}
	
					</div>

				</div>

			}

		</div>

	</div>

</div>
